import Resource from "@/components/Resource";
import { AuthGuard, LoginGuard, ResolveGuard } from "@/router/guards";
import { PERMISSIONS } from "@/enum/permissions.enum";

function page(path) {
	return () => import(`../pages/${path}`);
}
export default {
        path: "/finance",
        component: Resource,
        children: [
            {
                path: "",
                name: "finance.index",
                component: page("Index.vue"),
                beforeEnter: ResolveGuard([AuthGuard]),
                meta: {
                    permissions: [PERMISSIONS.VIEW_USER],
                    title: "Tổng quan",
                    breadcrumbs: [{ title: "Tài chính", name: "finance.index" }],
                    gtm: "Financial Dashboard"
                }
            },
            {
                path: "account-types",
                name: "finance.account-types",
                component: page("AccountTypes.vue"),
                beforeEnter: ResolveGuard([AuthGuard]),
                meta: {
                    permissions: [PERMISSIONS.VIEW_USER],
                    title: "Loại tài khoảng",
                    breadcrumbs: [
                        { title: "Tài chính", name: "finance.index" },
                        { title: "Loại tài khoản", name: "finance.account-types" }
                    ],
                    gtm: "Finance Account Types"
                }
            },
            {
                path: "accounts",
                name: "finance.accounts",
                component: page("Accounts.vue"),
                beforeEnter: ResolveGuard([AuthGuard]),
                meta: {
                    permissions: [PERMISSIONS.VIEW_USER],
                    title: "Tài khoản",
                    breadcrumbs: [
                        { title: "Tài chính", name: "finance.index" },
                        { title: "Tài khoản", name: "finance.accounts" }
                    ],
                    gtm: "Finance Accounts"
                }
            },
            {
                path: "accounts/:id",
                name: "finance.account-details",
                component: page("AccountView.vue"),
                beforeEnter: ResolveGuard([AuthGuard]),
                meta: {
                    permissions: [PERMISSIONS.VIEW_USER],
                    title: "Chi tiết tài khoản",
                    breadcrumbs: [
                        { title: "Tài chính", name: "finance.index" },
                        { title: "Tài khoản", name: "finance.accounts" },
                        { title: "Chi tiết", name: "finance.account-details" }
                    ],
                    gtm: "Finance Account Details"
                }
            },
            {
                path: "account-transfers",
                name: "finance.account-transfers",
                component: page("Transfers.vue"),
                beforeEnter: ResolveGuard([AuthGuard]),
                meta: {
                    permissions: [PERMISSIONS.VIEW_USER],
                    title: "Lịch sử giao dịch",
                    breadcrumbs: [
                        { title: "Tài chính", name: "finance.index" },
                        { title: "Lịch sử giao dịch", name: "finance.account-transfers" }
                    ],
                    gtm: "Finance Account Transfers"
                }
            },
            {
                path: "summary-transfers",
                name: "finance.summary-transfers",
                component: page("SummaryTransfer.vue"),
                beforeEnter: ResolveGuard([AuthGuard]),
                meta: {
                    permissions: [PERMISSIONS.VIEW_USER],
                    title: "Tổng hợp giao dịch",
                    breadcrumbs: [
                        { title: "Tài chính", name: "finance.index" },
                        { title: "Lịch sử giao dịch", name: "finance.account-transfers" },
                        { title: "Tổng hợp", name: "finance.summary-transfers" }
                    ],
                    gtm: "Finance Summary Transfers"
                }
            },
            {
                path: "add-transfer",
                name: "finance.add-transfer",
                component: page("AddTransfer.vue"),
                beforeEnter: ResolveGuard([AuthGuard]),
                meta: {
                    permissions: [PERMISSIONS.VIEW_USER],
                    title: "Tạo giao dịch mới",
                    breadcrumbs: [
                        { title: "Tài chính", name: "finance.index" },
                        { title: "Giao dịch", name: "finance.account-transfers" },
                        { title: "Tạo mới", name: "finance.add-transfer" }
                    ],
                    gtm: "Finance Add Transfer"
                }
            },
            {
                path: "view-transfer/:id",
                name: "ViewTransfer",
                component: page("ViewTransfer.vue"),
                beforeEnter: ResolveGuard([AuthGuard]),
                meta: {
                    permissions: [PERMISSIONS.VIEW_USER],
                    title: "Chi tiết giao dịch",
                    breadcrumbs: [
                        { title: "Tài chính", name: "finance.index" },
                        { title: "Giao dịch", name: "finance.account-transfers" },
                        { title: "Chi tiết", name: "ViewTransfer" }
                    ],
                    gtm: "Finance View Transfer"
                }
            },
            {
                path: "reports",
                name: "finance.reports",
                component: page("Reports.vue"),
                beforeEnter: ResolveGuard([AuthGuard]),
                meta: {
                    permissions: [PERMISSIONS.VIEW_USER],
                    title: "Báo cáo",
                    breadcrumbs: [
                        { title: "Tài chính", name: "finance.index" },
                        { title: "Báo cáo", name: "finance.reports" }
                    ],
                    gtm: "Finance Reports"
                }
            },
            {
                path: "report-builder",
                name: "finance.report-builder",
                component: page("ReportBuilder.vue"),
                beforeEnter: ResolveGuard([AuthGuard]),
                meta: {
                    permissions: [PERMISSIONS.VIEW_USER],
                    title: "Xây dựng Báo cáo",
                    breadcrumbs: [
                        { title: "Tài chính", name: "finance.index" },
                        { title: "Báo cáo", name: "finance.reports" },
                        { title: "Xây dựng Báo cáo", name: "finance.report-builder" }
                    ],
                    gtm: "Finance Report Builder"
                }
            },
        ]
    };